import { useCallback, useEffect } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import useStateAsync from '@restart/hooks/useStateAsync';
import useTimeout from '@restart/hooks/useTimeout';
import LocalTokenStorage from './LocalTokenStorage';
var localTokenStorage = new LocalTokenStorage();
export default function useAuthToken(_ref) {
  var onTokenExpired = _ref.onTokenExpired,
      _ref$leeway = _ref.leeway,
      leeway = _ref$leeway === void 0 ? 0 : _ref$leeway,
      _ref$tokenStorage = _ref.tokenStorage,
      tokenStorage = _ref$tokenStorage === void 0 ? localTokenStorage : _ref$tokenStorage;
  var timeout = useTimeout();

  var _useStateAsync = useStateAsync(function () {
    return tokenStorage.load();
  }),
      tokenResponse = _useStateAsync[0],
      setTokenResponse = _useStateAsync[1];

  var scheduleExpireTokenResponse = useEventCallback(function (nextTokenResponse) {
    timeout.set(function () {
      return onTokenExpired && onTokenExpired(nextTokenResponse);
    }, Math.max(nextTokenResponse.expiresAt - Date.now() - leeway, 0));
  });
  useEffect(function () {
    if (tokenResponse) scheduleExpireTokenResponse(tokenResponse);
  }, [scheduleExpireTokenResponse, tokenResponse]);
  var updateTokenResponse = useCallback(function (nextTokenResponse) {
    timeout.clear();

    if (nextTokenResponse) {
      tokenStorage.save(nextTokenResponse);
    } else {
      tokenStorage.clear();
    }

    return setTokenResponse(nextTokenResponse);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [tokenStorage]);
  return [tokenResponse, updateTokenResponse];
}